<template>
  <section>
    <draw-signature></draw-signature>
  </section>
</template>

<script>
import DrawSignature from '@/components/DrawSignature.vue';
export default {
components:{
    DrawSignature
}
}
</script>

<style>

</style>